module.exports = __webpack_public_path__ + "img/buy.c0bcd80.svg";